import {useReducedMotion} from 'framer-motion'
import React from 'react'
import Slider, {Settings} from 'react-slick'

import {MIN_TARGET_SIZE} from '@/theme/sizing'
import {theme} from '@/theme/theme'

type CarouselProps = {
  settings: Settings
  onSwipe?: () => void
}

const Carousel: React.FC<React.PropsWithChildren<CarouselProps>> = ({
  children,
  settings,
  onSwipe,
}) => {
  const shouldReduceMotion = useReducedMotion()

  return (
    <div className="carousel">
      <Slider {...settings} autoplay={settings.autoplay && !shouldReduceMotion} onSwipe={onSwipe}>
        {children}
      </Slider>

      <style jsx global>{`
        .carousel .slick-slider {
          margin: 0 auto;
          max-width: 700px;
        }
        .carousel .slick-prev {
          left: -40px;
        }
        .carousel .slick-next {
          right: -40px;
        }
        .carousel .slick-prev:before,
        .carousel .slick-next:before {
          content: '';
          position: absolute;
          opacity: 1;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-image: url('/images/icons/chevron.svg');
          background-repeat: no-repeat;
          background-position: center;
          background-size: 18px;
        }
        .carousel .slick-prev:before {
          transform: rotate(180deg);
        }
        .carousel .slick-dots {
          position: relative;
          bottom: 0;
          margin-top: 24px;
        }
        .carousel .slick-dots li {
          margin: 0;
          height: ${MIN_TARGET_SIZE}px;
          width: ${MIN_TARGET_SIZE}px;
        }
        .carousel .slick-dots li button {
          padding: 0;
        }
        .carousel .slick-dots li button:before {
          opacity: 1;
          color: ${theme.palette.gray[400]};
        }
        .carousel .slick-dots li.slick-active button:before {
          opacity: 1;
          color: ${theme.palette.text.default};
        }
      `}</style>
    </div>
  )
}
export default Carousel
